// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1zean","title":"Header_title__xoE1T","side":"Header_side__3PpjC"};